import type { PublicSlotKey } from '@/apilib';
import type { ComponentFocusModeApi } from './componentFocusModeApi';

export const ComponentFocusModeApiKey: PublicSlotKey<ComponentFocusModeApi> = {
  name: 'ComponentFocusModeApi',
  public: true,
};
